import Image from 'next/image';

/**
 * 目的: 画像未設定時に表示する共通プレースホルダー（結会ロゴ）
 * 引数:
 * - size: 表示サイズ（px）
 * - className: 追加のCSSクラス
 * 戻り値: JSX.Element
 */
export function LogoPlaceholder({
  size = 56,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <Image
      src='/assets/img/logo-yuikai.png'
      alt='結会'
      width={size}
      height={size}
      quality={75}
      className={`object-contain opacity-80 ${className}`}
    />
  );
}

